/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespBreadcrumbs_item = {
    readonly breadcrumbs: ReadonlyArray<{
        readonly text: string | null;
        readonly path: string | null;
        readonly isLinkable: boolean | null;
    }> | null;
    readonly " $refType": "PdpRespBreadcrumbs_item";
};
export type PdpRespBreadcrumbs_item$data = PdpRespBreadcrumbs_item;
export type PdpRespBreadcrumbs_item$key = {
    readonly " $data"?: PdpRespBreadcrumbs_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespBreadcrumbs_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespBreadcrumbs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '16d087bc64d1129aae9ecf5514c0705d';
export default node;
